<!-- declared up here so the form's (ngSubmit) can be guarded too: Enter in the hours field submits the form -->
@let isSubmitting = isSubmitting$ | async;
<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <!-- existing hours have an id (the same check save and delete use); an "add hours" day doesn't -->
  <h6 mat-dialog-title>
    {{ data.hoursExtended?.leaveCaseHoursID != null ? data.sysText.editLeaveHours_header : data.sysText.addLeaveHours_header }},
    {{ data.event.start | date }}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="close(false)" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <form [formGroup]="form" (ngSubmit)="!isSubmitting && onSubmit()">
    <div class="form-fields">
      <div class="container hours-taken">
        <mat-icon [ngClass]="{ focus: input.focused }">schedule</mat-icon>
        <mat-form-field color="accent">
          <mat-label>{{ data.sysText.numberOfHours | titlecase }}</mat-label>
          <input matInput #input="matInput" type="number" [formControl]="form.controls.hours" autocomplete="off"/>
          @if (form.controls.hours.errors?.msError) {
            <mat-error>{{ $safeNavigationMigration(form.controls.hours.errors?.msError) | replaceBankNames: data.caseDetails.leaveHoursBanksBuckets }}</mat-error>
          }
          @if (form.controls.hours.errors?.pattern) {
            <mat-error>{{ data.sysText.invalidHoursError | capitalizefirst }}</mat-error>
          }
          @if (form.controls.hours.errors?.hoursGreaterThan24) {
            <mat-error>{{ data.sysText.hoursGreaterThan24Error | capitalizefirst }}</mat-error>
          }
          @if (showFullDayWarning) {
            <mat-hint class="hint-red">{{ data.sysText.notFullWorkdayError }}</mat-hint>
          }
          @if (showOtherLeavesWarn) {
            <mat-hint class="hint-blue">{{ data.sysText.otherLeavesWarn }}</mat-hint>
          }
          <!-- mat hint for spacing -->
          @if (!showFullDayWarning && !showOtherLeavesWarn) {
            <mat-hint></mat-hint>
          }
        </mat-form-field>
      </div>
      @if (showFullDayControl) {
        <div class="check-container">
          <mat-icon [ngClass]="{ focus: input.focused }">today</mat-icon>
          <mat-checkbox
            class="full-day-check"
            [formControl]="form.controls.isFullDay">{{ data.sysText.fullWorkday + (fullDayIncrement != null ? ' (' + fullDayIncrement + 'h' + ')'  : '') }}
          </mat-checkbox>
        </div>
      }
      @if (showSomeBanksFullDayIncRestrictHint) {
        <mat-hint class="bottom-hint hint-blue">{{ data.sysText.someBanksFullDayIncRestrictHint }}</mat-hint>
      }
      @if (showAllBanksFullDayIncRestrictHint) {
        <mat-hint class="bottom-hint hint-blue">{{ data.sysText.allBanksFullDayIncRestrictHint }}</mat-hint>
      }
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="space-between">
  @let canDelete = data.hoursExtended?.leaveCaseLeaveHours != null;
  <!-- delete and save share isSubmitting$, so submittingAction says which one was pressed: that one shows the spinner (showProgress)
  and the "loading" label. both stay focusable while busy (disabledInteractive), so the guards repeat their checks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting || !canDelete"
    disabledInteractive
    [showProgress]="isSubmitting && submittingAction === 'delete'"
    [attr.aria-label]="isSubmitting && submittingAction === 'delete' ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && canDelete && onDelete()">
    {{data.sysText.deleteTime}}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
  <div>
    @if (!(isMobile$ | async)) {
      <button
        mat-stroked-button
        class="button"
        color="accent"
        [disabled]="isSubmitting"
        (click)="close(false)">
        {{data.sysText.cancel}}
      </button>
    }
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      disabledInteractive
      [showProgress]="isSubmitting && submittingAction === 'save'"
      [attr.aria-label]="isSubmitting && submittingAction === 'save' ? data.sysText.submitting_ariaLabel : null"
      (click)="!isSubmitting && onSubmit()">
      {{data.sysText.save}}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>
  </div>
</mat-dialog-actions>